/* global clearInterval, console, CustomFunctions, setInterval */

/**
 * Looks up specified information from SEC EDGAR based on stock ticker.
 * @customfunction 
 * @helpurl https://www.exceledgar.com/help.html
 * @param ticker Stock ticker
 * @param info Requested information on the security
 * @param period period of data requested (0 = most recent, -1 second most recent)
 * @returns {any[][]} The requested data for your specified security.
 */
export async function edgar(ticker: string, info: string, period: number) {
  let url = '';
  let output = [];
  if (!ticker) {  
   return 'NO VALUE';
  }
  let userStr = await getUser();
  const infoList = info.split(',');
  if (infoList.length > 1) {
    url = 'https://p4oxbw2wjuu3rjldsxf4lixvoi0apifd.lambda-url.us-west-2.on.aws/' + ticker;
  } else {
    url ='https://p4oxbw2wjuu3rjldsxf4lixvoi0apifd.lambda-url.us-west-2.on.aws/' + ticker + '/' + info;
  }
  let data = await retrieveHttp(url, {name: userStr});
  if (infoList.length > 1) {
    for (let i=0; i<infoList.length; i++) {
      // const? 
      let allData = data['facts']['us-gaap'][infoList[i]];
      let elemData = Object.values(allData['units'])[0];
      output.push(elemData.at(period-1)['val']);
    }
  } else {
    const allData = Object.values(data['units'])[0];
    output.push(allData.at(period-1)['val']);
  }
  return [output];
}

/**
 * Looks up specified information from SEC EDGAR based on stock ticker and date.
 * @customfunction 
 * @helpurl https://www.exceledgar.com/help.html
 * @param ticker Stock ticker
 * @param info Requested information on the security
 * @param period period of data requested (eg: "FY2024", "Q12025")
 * @returns {any} The requested data for your specified security.
 */
export async function edgarByDate(ticker: string, info: string, period: string) {
  const url = 'https://p4oxbw2wjuu3rjldsxf4lixvoi0apifd.lambda-url.us-west-2.on.aws/' + ticker + '/calendar/' + info;
  let output = [];
  let userStr = await getUser();
  const infoList = info.split(',');
  if (!ticker) {  
   return 'No Ticker';
  }
  if (infoList.length > 1) {
    return 'Invalid Data Request';
  }
  let data = await retrieveHttp(url, {name: userStr});
  const amount = data[period]['val'];
  return amount;
}

function retrieveHttp (url:string, params={}) {
  try {
    if (Object.keys(params).length > 0) {
      url = url + '?' + new URLSearchParams(params).toString();
    }
    return fetch(url)
      .then(response => response.json())
  } catch (error) {
    console.error(error);
  }
}

async function getUser() {
  let user = '';
  try {
    await Excel.run(async (context) => {
      const documentProperties = context.workbook.properties;
      documentProperties.load('lastAuthor');
      await context.sync();
      user = documentProperties.lastAuthor;
    });
    return user;
  } catch (error) {
    console.error(error);
  }
}
CustomFunctions.associate("EDGAR", edgar);
CustomFunctions.associate("EDGARBYDATE", edgarByDate);